import { IntlProvider } from 'react-intl';
import enMessages from './locales/en.json';

// Helper function to flatten nested objects for react-intl
const flattenMessages = (nestedMessages, prefix = '') => {
  return Object.keys(nestedMessages).reduce((messages, key) => {
    const value = nestedMessages[key];
    const prefixedKey = prefix ? `${prefix}.${key}` : key;

    if (typeof value === 'string') {
      messages[prefixedKey] = value;
    } else {
      Object.assign(messages, flattenMessages(value, prefixedKey));
    }

    return messages;
  }, {});
};

const messages = {
  en: flattenMessages(enMessages),
};

export const getLocale = () => {
  // Default to English, can be extended to detect browser locale
  return 'en';
};

export const getMessages = (locale) => {
  const localeMessages = messages[locale] || messages.en;
  // Debug: log to verify messages are loaded
  if (process.env.NODE_ENV === 'development') {
    console.log('i18n - Loaded messages for locale:', locale);
    console.log('i18n - Messages object type:', typeof localeMessages);
    console.log(
      'i18n - Has projects.prosperity.introduction:',
      !!localeMessages['projects.prosperity.introduction']
    );
    console.log(
      'i18n - Prosperity introduction value:',
      localeMessages['projects.prosperity.introduction']?.substring(0, 100)
    );
    console.log(
      'i18n - Has projects.prosperity.workflows.financialClarity.title:',
      !!localeMessages['projects.prosperity.workflows.financialClarity.title']
    );
    console.log(
      'i18n - Financial clarity title:',
      localeMessages['projects.prosperity.workflows.financialClarity.title']
    );
    console.log('i18n - Sample keys:', Object.keys(localeMessages).slice(0, 10));
  }
  return localeMessages;
};

export { IntlProvider };
export default { getLocale, getMessages, IntlProvider };
